import PanelBoxLayout from 'components/layout/panelBox';

import * as T from 'common/types';
import * as S from './styles';
import Gap from 'components/gap';
import { durationTypeEnum } from 'common/enums';

interface IProps {
  data: T.Pages.ErpResponse;
}

export default function ReservationDetailInfo({ data }: IProps) {
  return (
    <S.Content>
      <PanelBoxLayout style={{ padding: '20px 30px' }}>
        <S.Head>Details</S.Head>
        <Gap size="10px" />
        <S.Div className="row">
          <S.Div className="col-6">
            <S.Item>
              <S.Title>Requested By</S.Title>
              <S.Text>{data?.createdByUser?.displayName || '-'}</S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-6">
            <S.Item>
              <S.Title>Awaiting for</S.Title>
              <S.Text>
                {data?.awaitingForManager
                  ? 'Line Manager: ' + data?.awaitingForUser?.displayName
                  : data?.awaitingForRole
                    ? 'Role: ' + data?.awaitingForRole
                    : '-'}
              </S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-6">
            <S.Item>
              <S.Title>Request Type</S.Title>
              <S.Text>{`${data?.absenceTypeName || '-'}`}</S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-6">
            <S.Item>
              <S.Title>Status</S.Title>
              <S.Text>{`${data?.status?.value || '-'}`}</S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-6">
            <S.Item>
              <S.Title>Duration</S.Title>
              <S.Text>
                {data?.duration +
                  ' ' +
                  // @ts-ignore
                  durationTypeEnum[data?.durationType] || '-'}
              </S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-6">
            <S.Item>
              <S.Title>Last Change By User</S.Title>
              <S.Text>{data?.lastChangeByUser?.displayName || 'Erp System'}</S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-md-6">
            <S.Item>
              <S.Title>Start</S.Title>
              <S.Text>
                {data?.startDate} {data?.startTime ? data?.startTime : ''}{' '}
                {data?.startDateDurationIsFull || '-'
                  ? '(Full)'
                  : data?.startDateDurationIsFull === false
                    ? '(Half)'
                    : ''}
              </S.Text>
            </S.Item>
          </S.Div>
          <S.Div className="col-md-6">
            <S.Item>
              <S.Title>End</S.Title>
              <S.Text>
                {data.endDate} {data?.endTime ? data?.endTime : ''}{' '}
                {data?.endDateDurationIsFull ? '(Full)' : data?.endDateDurationIsFull === false ? '(Half)' : ''}
              </S.Text>
            </S.Item>
          </S.Div>
        </S.Div>
        <Gap size="20px" />
        <S.GridMain>
          <S.Div>
            <S.Head>Attachments</S.Head>
            <Gap size="15px" />
            {data?.attachments?.length ? (
              data?.attachments?.map((item) => (
                <S.Div className="w-full">
                  <S.UserCard>
                    <S.Grid>
                      <S.Div className="full">
                        <S.MainTitle>
                          <h6 style={{ margin: 0 }}>{item?.fileName}</h6>
                          <S.Text style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                            <span>{item.fileType}</span>
                          </S.Text>
                        </S.MainTitle>

                        <a href={item.url} target="_blank" rel="noreferrer">
                          Link
                        </a>
                      </S.Div>
                    </S.Grid>
                  </S.UserCard>
                </S.Div>
              ))
            ) : (
              <S.Message>There is no attachment.</S.Message>
            )}
          </S.Div>
          <S.Div>
            <S.Head>History</S.Head>
            <S.PeopleContainer>
              {data?.history?.map((item) => (
                <S.Div className="w-full">
                  <S.UserCard>
                    <S.Grid>
                      <S.Div className="full">
                        <S.MainTitle>
                          <h6 style={{ margin: 0 }}>
                            {item?.createdByUser?.displayName ? item?.createdByUser?.displayName : 'Erp System'}
                          </h6>
                          <S.Text style={{ display: 'flex', flexWrap: 'wrap', gap: 5 }}>
                            <span>{item.approvalStatus?.value || item.status?.value}</span>
                          </S.Text>
                        </S.MainTitle>
                        <p style={{ marginBottom: 5 }}>{item.comment}</p>
                        <S.Text>{new Date(item.createdAt).toLocaleString()}</S.Text>
                      </S.Div>
                    </S.Grid>
                  </S.UserCard>
                </S.Div>
              ))}
            </S.PeopleContainer>
          </S.Div>
        </S.GridMain>

        <Gap size="20px" />
      </PanelBoxLayout>
    </S.Content>
  );
}
